import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	maxDailyStockNum: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetViewModel: (
		values: { key: "maxDailyStockNum"; value: ForNodeType<InputMaybe<number> | undefined> | undefined }[],
	) => void;
};

export const useOptionMaxDailyStockNum = ({ maxDailyStockNum, onSetViewModel }: Props) => {
	const isEdited = maxDailyStockNum?.isEdited ?? false;
	const hasError = maxDailyStockNum?.error !== undefined;

	const onSetMaxDailyStockNum = (input: number | undefined) => {
		onSetViewModel([{ key: "maxDailyStockNum", value: { isEdited: true, value: input } }]);
	};

	return {
		isEdited,
		hasError,
		maxDailyStockNum,
		onSetMaxDailyStockNum,
	};
};
